import React from 'react';
import { Component } from '@poa/core';
import { observable, action } from '@poa/state';

import ArrowBottomIcon from './icons/arrow-bottom';

class Dropdown extends React.Component {
  isOpen = observable(false);

  toggleState = action(() => {
    if (!this.isOpen.get()) {
      document.addEventListener('click', this.handleOutsideClick);
    } else {
      document.removeEventListener('click', this.handleOutsideClick);
    }

    this.isOpen.set(!this.isOpen.get());
  });

  handleOutsideClick = e => {
    if (this.node && this.node.contains(e.target)) {
      return;
    }

    if (e.defaultPrevented) {
      return;
    }

    this.toggleState();
  };

  close = () => {
    document.removeEventListener('click', this.handleOutsideClick);
    this.isOpen.set(false);
  };

  render() {
    const { label, selected, children, render, filterColor } = this.props;

    return (
      <div
        className="filter"
        onClick={this.toggleState}
        style={{ cursor: 'pointer' }}
        ref={node => (this.node = node)}
      >
        <span 
        className="filter__label" 
        style={{color: filterColor ? "#fff" : "#000"}}>
          {label}
          </span>
        <div className="filter__wrap">
          <div className={`common-filter${this.isOpen.get() ? ' is-open' : ''}`}>
            <div className="common-filter__out">{selected}</div>
            <button className="common-filter__toggle">
              <ArrowBottomIcon />
            </button>
            <div className="common-filter__dropdown" onClick={this.toggleState}>
              {render ? render(this.isOpen.get(), () => this.close()) : children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Component()(Dropdown);
